module.exports = __webpack_public_path__ + "img/logo-mobiplus-branco.6b45aa6d.png";